import { SaleOrderModel } from './sale-orders'
import { WarehouseModel } from './warehouse'
import moment from 'moment'
// voucher status
export const SALE_ORDER_DELIVERY_STATUS_JUST_PLACED = 1
export const SALE_ORDER_DELIVERY_STATUS_APPROVED = 2
export const SALE_ORDER_DELIVERY_STATUS_CANCELLED = 3

export const SALE_ORDER_DELIVERY_HOD_STATUS_JUST_PLACED = 1
export const SALE_ORDER_DELIVERY_HOD_STATUS_APPROVED = 2
export const SALE_ORDER_DELIVERY_HOD_STATUS_CANCELLED = 3
// export const SALE_ORDER_DELIVERY_STATUS_POSTED = 3;

export const SALE_ORDER_DELIVERY_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Cancelled',
  // 3: 'Posted',
}

export const SALE_ORDER_DELIVERY_HOD_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Cancelled',
  // 3: 'Posted',
}

export const SALE_ORDER_DELIVERY_STATUS_DROPDOWN_OPTIONS = [
  {
    value: SALE_ORDER_DELIVERY_STATUS_JUST_PLACED,
    label: SALE_ORDER_DELIVERY_STATUS_NAME[SALE_ORDER_DELIVERY_STATUS_JUST_PLACED],
  },
  {
    value: SALE_ORDER_DELIVERY_STATUS_APPROVED,
    label: SALE_ORDER_DELIVERY_STATUS_NAME[SALE_ORDER_DELIVERY_STATUS_APPROVED],
  },
  // { value: SALE_ORDER_DELIVERY_STATUS_POSTED, label: SALE_ORDER_DELIVERY_STATUS_NAME[STATUS_POSTED] },
  {
    value: SALE_ORDER_DELIVERY_STATUS_CANCELLED,
    label: SALE_ORDER_DELIVERY_STATUS_NAME[SALE_ORDER_DELIVERY_STATUS_CANCELLED],
  },
]

export const SALE_ORDER_DELIVERY_HOD_STATUS_DROPDOWN_OPTIONS = [
  {
    value: SALE_ORDER_DELIVERY_HOD_STATUS_JUST_PLACED,
    label: SALE_ORDER_DELIVERY_STATUS_NAME[SALE_ORDER_DELIVERY_HOD_STATUS_JUST_PLACED],
  },
  {
    value: SALE_ORDER_DELIVERY_HOD_STATUS_APPROVED,
    label: SALE_ORDER_DELIVERY_HOD_STATUS_NAME[SALE_ORDER_DELIVERY_HOD_STATUS_APPROVED],
  },
  {
    value: SALE_ORDER_DELIVERY_HOD_STATUS_CANCELLED,
    label: SALE_ORDER_DELIVERY_HOD_STATUS_NAME[SALE_ORDER_DELIVERY_STATUS_CANCELLED],
  },
]

export const PRINT_HISTORY_YES = 1
export const PRINT_HISTORY_NO = 2

export const PRINT_HISTORY_NAMES = {
  1: 'Yes',
  2: 'No',
}
export const PRINT_HISTORY_DROPDOWN_OPTIONS = [
  { value: PRINT_HISTORY_YES, label: PRINT_HISTORY_NAMES[PRINT_HISTORY_YES] },
  { value: PRINT_HISTORY_NO, label: PRINT_HISTORY_NAMES[PRINT_HISTORY_NO] },
]

export const IS_PRINTED_YES = 1
export const IS_PRINTED_NO = 2

export const IS_PRINTED_NAMES = {
  1: 'Yes',
  2: 'No',
}
export const IS_PRINTED_DROPDOWN_OPTIONS = [
  { value: IS_PRINTED_YES, label: IS_PRINTED_NAMES[IS_PRINTED_YES] },
  { value: IS_PRINTED_NO, label: IS_PRINTED_NAMES[PRINT_HISTORY_NO] },
]

export const SALE_ORDER_DELIVERY_CURRENCY_SYMBOL = 'PKR'

export const MATERIAL_LIFTED_FROM_INTERNAL_STORES = 'internal_stores'
export const MATERIAL_LIFTED_FROM_EXTERNAL_STORES = 'external_stores'
export const MATERIAL_LIFTED_FROM_OPTIONS = [
  { value: MATERIAL_LIFTED_FROM_INTERNAL_STORES, label: 'Internal Stores' },
  { value: MATERIAL_LIFTED_FROM_EXTERNAL_STORES, label: 'External Stores' },
]

export const SaleOrderDeliveryModel = {
  id: 0,
  code: 'Auto Generated',
  branch_id: 0,
  branch: { name: '' },
  party_id: null,
  party: { name: '' },
  project_id: null,
  project: { name: '' },
  warehouse_id: 0,
  warehouse: { ...WarehouseModel },
  material_lifted_from: '',
  factory_id: null,
  extract_number: '',
  factory: { name: '' },
  sale_order_id: 0,
  sale_order: { ...SaleOrderModel },
  remarks: '',
  delivery_date: moment().format('YYYY-MM-DD'),
  status: SALE_ORDER_DELIVERY_STATUS_JUST_PLACED,
  approved_at: '',
  approved_by: { name: '' },
  created_by_id: 0,
  created_by: { name: '' },
  updated_by_id: 0,
  updated_by: { name: '' },
  created_at: '',
  manual_do_no: '',
  print_history: PRINT_HISTORY_NO,
  attachments: [],
  sale_order_delivery_details: [],
}

export const DELIVERING_QUANTITY_ROUND_DECIMAL_PLACES = 6
